import { customAlphabet } from 'nanoid';

export function shortId(size = 16) {
  return customAlphabet('abcdefghijklmnopqrstuvwxyz0123456789', size)();
}
